var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.resolveLayoutVariant,{tag:"component",class:("skin-variant--" + _vm.appSkinVariant)},[_c('transition',{attrs:{"name":_vm.appRouteTransition,"mode":"out-in","appearcc":""}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }